import { Heading } from '@chakra-ui/react'
export default function NotfoundPage() {
  return (
      <Heading>Page Not Found</Heading>
  )
}
